<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">页码：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="页码"
                clearable
                v-model="queryData.page"
              ></el-input>
            </div>
          </el-col>
          <!-- <el-col :span="6">
            <div class="search-form-label">台数：</div>
            <div class="search-form-controller">
              <el-input size="mini" placeholder="台数" clearable v-model="queryData.table_number"></el-input>
            </div>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-autocomplete
            style="margin-left: 20px"
            size="mini"
            popper-class="my-autocomplete"
            v-model="queryData.product_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入样本册"
            @select="handleSelect"
            @blur="handblur"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
          <span
            ><label style="margin-left: 30px;font-size: 16px;">定数：</label
            ><label style="margin-left: 5px;font-size: 16px;color: red;">{{
              queryData.product_count
            }}</label></span
          >
          <el-select
            size="mini"
            v-model="queryData.bupin_name"
            placeholder="请选择"
            style="margin-left:20px"
          >
            <el-option
              v-for="item in bupinArr"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            icon="el-icon-delete"
            size="mini"
            @click="deleteHandler"
          >删除样本册</el-button>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          :row-class-name="tableRowClassName"
          @row-dblclick="doubleClick"
        >
          <el-table-column
            label="部品名称"
            width="200"
            prop="base_material_name"
            align="center"
          ></el-table-column>
          <el-table-column
            label="页码"
            prop="page"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="担当"
            prop="undertake"
            width="100"
            align="center"
          ></el-table-column>
          <!-- <el-table-column label="台数" prop="table_number" width="120" align="center"></el-table-column> -->
          <el-table-column
            label="已入库"
            prop="instore_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="已出库"
            prop="outstore_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="不良品出库"
            prop="outreject_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="不良品回料"
            prop="inreject_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库总数"
            prop="allinstore_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            label="在库"
            prop="avaliable_count"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column align="center"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <el-dialog
        :visible="isShow"
        :width="width"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :append-to-body="true"
        :show-close="false"
      >
        <div slot="title" class="dialog-title-container">
          <span class="title-label"><i class="el-icon-s-grid"></i>明细</span>
          <i class="el-icon-error" @click="close"></i>
        </div>
        <div class="dialog-search-container">
          <el-row>
            <el-col :span="1" style="margin-top:3px">类别</el-col>
            <el-col :span="8">
              <el-select
                size="mini"
                v-model="searchStore"
                placeholder="请选择"
                @change="categoryChange"
              >
                <el-option
                  v-for="(u, index) in storeOption"
                  :key="index"
                  :label="u.label"
                  :value="u.label"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="dialog-main-container">
          <el-table
            :data="dsDetail"
            size="mini"
            height="410px"
            style="width: 100%;"
            stripe
            border
            header-row-class-name="list-header-row"
            row-class-name="list-row"
          >
            <el-table-column
              label="类别"
              prop="category"
              align="center"
            ></el-table-column>
            <el-table-column
              label="数量"
              prop="number"
              align="center"
            ></el-table-column>
            <el-table-column
              label="日期"
              prop="date"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
    <!--列表数据 结束-->
  </div>
</template>
<style>
.el-table .warning-row {
  background: #ee6363;
}
</style>
<script>
export default {
  data: function() {
    return {
      ds: [],
      dsDetail: [],
      selectedIds: [],
      bupinArr: [],
      // 分页
      queryData: {
        page: "",
        // table_number: '',
        bupin_name:'',
        product_id: "",
        product_name: "",
        product_count: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      productList: [],
      product_check: "",
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      isShow: false,
      width: "50%",
      searchStore: "",
      storeOption: [
        { label: "已入库" },
        { label: "已出库" },
        { label: "不良品入库" },
        { label: "不良品出库" }
      ],
      base_material_id: "",
      page: ""
    };
  },
  created: function() {},
  mounted: function() {
    this.bupinArr = [{ value: "所有" }, { value: "台纸" }, { value: "部品" }];
    this.queryData.bupin_name = '所有';
    this.loadProduct();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 样本册搜索
    loadProduct: function() {
      let _this = this;
      _this.queryData.product_count = "";
      _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
        _this.productList = res.data.dataList;
      });
    },
    querySearchAsync: function(queryString, cb) {
      this.product_check = "false";
      var results = queryString
        ? this.productList.filter(this.createStateFilter(queryString))
        : this.productList;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 500 * Math.random());
    },
    createStateFilter: function(queryString) {
      return product => {
        return product.name.indexOf(queryString) > -1;
      };
    },
    handleSelect: function(item) {
      let _this = this;
      _this.product_check = "true";
      _this.queryData.product_name = item.name;
      _this.queryData.product_id = item.id;
      // 获取样本册对应定数
      // _this.post(_this.$apis.getProductCount, { ProductId: _this.queryData.product_id }, function (res) {
      //   let _json = res.data
      //   if (_json.status && _json.status === 'logout') {
      //     _this.logout()
      //   } else {
      //     _this.queryData.product_count = _json.product_count
      //   }
      // })
      _this.loadData();
    },
    handleIconClick: function(ev) {
      console.log(ev);
    },
    handblur: function() {
      if (this.product_check === "false") {
        this.queryData.product_name = "";
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getSummaryList, this.queryData, function(res) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
          _this.queryData.product_count = _json.product_count;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.page = "";
        // this.queryData.table_number = ''
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    // 导出excel
    exportHandler: function() {
      let _this = this;
      if (_this.queryData.product_name === "") {
        _this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        _this.post(_this.$apis.exportSummaryList, _this.queryData, function(
          res
        ) {
          let _json = res.data;
          if (_json.fileUrl !== "") {
            window.location = _this.$apiroot + _json.fileUrl;
          } else {
            _this.$router.push({
              path: "/"
            });
          }
        });
      }
    },
    // 删除样本册
    deleteHandler: function () {
      debugger;
      let _this = this
      if (_this.queryData.product_name === "") {
        _this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        _this.$confirm('确定删除 ' + _this.queryData.product_name + ' ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 显示密码输入对话框
          _this.$prompt('请输入密码以确认删除操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password', // 设置为密码输入框
            inputValidator: (value) => {
              if (!value) {
                return '请输入密码'; // 输入为空时的提示信息
              }
              else if (value !== '886886') {
                return '输入密码错误，请重新输入密码！'; // 密码错误时的提示信息
              }
              // 这里可以添加更多的验证逻辑，例如密码是否正确
              // 如果返回 undefined 或 true，则表示验证通过
            },
            inputErrorMessage: '密码错误' // 验证失败时的提示信息
          }).then(({ value }) => {
            // 用户点击确定并输入了密码
            let _params = {
              product_name: _this.queryData.product_name
            };
            _this.post(_this.$apis.delDefaultSample, _params, function (res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            }
            );
          }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        });

        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    doubleClick: function(row, column, event) {
      this.isShow = true;
      this.dsDetail = [];
      this.searchStore = "";
      this.base_material_id = row.base_material_id;
      this.page = row.page;
      let param = {
        category: "所有",
        product_id: this.queryData.product_id,
        base_material_id: this.base_material_id,
        page: this.page
      };
      this.loadDetailData(param);
    },
    categoryChange: function(value) {
      let param = {
        category: value,
        product_id: this.queryData.product_id,
        base_material_id: this.base_material_id,
        page: this.page
      };
      this.loadDetailData(param);
    },
    loadDetailData: function(param) {
      let _this = this;
      _this.post(_this.$apis.getDetailData, param, function(res) {
        let _json = res.data;
        _this.dsDetail = _json.datalist;
      });
    },
    close: function() {
      this.isShow = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (
        parseInt(row.allinstore_count) < parseInt(this.queryData.product_count)
      ) {
        return "warning-row";
      } else {
        return "";
      }
    }
  },
  components: {}
};
</script>
